import React from 'react';
import {
  ClassroomTeacherWorkEditorPage,
  quizWorkEditorConfig,
} from './ClassroomTeacherWorkEditorPage';

const ClassroomTeacherQuizEditorPage: React.FC = () => (
  <ClassroomTeacherWorkEditorPage config={quizWorkEditorConfig} />
);

export default ClassroomTeacherQuizEditorPage;
